import styled from 'styled-components';
import { NiceBlue, WhiteFour, WhiteThree } from '../../styles/Colours';
import { Button } from '../Buttons/ButtonStyles';
import { CheckboxComponent } from '../Inputs/InputStyles';

export const Modal = styled.div`
  position: fixed;
  display: inline-block;
  width: 100%;
  height: 100vh;
  top: 0;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 999;
  background: ${NiceBlue};
  transform-origin: center right;
  transition: all 0.2s ease;
  transform: ${props =>
    props.state === 'entered' ? 'scale(1,1)' : 'scale(0,1)'};
`;

export const CloseIcon = styled.div`
  position: absolute;
  top: 35px;
  right: 35px;
  color: ${WhiteFour};
  font-size: 30px;
  cursor: pointer;
  z-index: 999;
`;

export const LoginSection = styled.div`
  display: inline-block;
  width: 100%;
  text-align: left;
  min-height: 100vh;
  padding-bottom: 150px;
  position: relative;

  ${CheckboxComponent} {
    margin-top: 10px;
  }
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: ${WhiteFour};
  margin-top: 100px;
`;

export const Subtitle = styled.div`
  font-size: 24px;
  font-weight: 300;
  color: ${WhiteFour};
`;

export const Forgot = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: ${WhiteFour};
  margin-top: 20px;
  cursor: pointer;
  margin-bottom: 10px;
`;

export const Disclaimer = styled.div`
  position: absolute;
  bottom: 20px;
  left: 0;
`;

export const Terms = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: ${WhiteFour};

  a {
    color: ${WhiteFour};
    text-decoration: none;

    &:hover {
      color: ${WhiteFour};
      text-decoration: underline;
    }
  }
`;
export const Copyright = styled.div`
  margin-top: 20px;
  color: ${WhiteThree};
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;

  a,
  a:hover,
  a:focus,
  a:active {
    color: ${WhiteThree};
  }
`;

export const Form = styled.form`
  margin-top: 60px;

  ${Button} {
    float: right;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Login/LoginStyles.js